var map = {
	"./logo_bd.png": "9bzd",
	"./logo_im.png": "5tF2",
	"./logo_sb.png": "3DeO",
	"./logo_ss.png": "35D4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fMoM";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport ^\.\/logo_.*\.png$
// module id = fMoM
// module chunks = 3